import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="relative z-10 mt-auto w-full bg-black py-12 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-6">
          <div className="flex items-center gap-3 text-white">
            <span className="material-symbols-outlined text-green-500">token</span>
            <span className="font-mono text-sm tracking-widest uppercase">StreetMoneyGaming // V2</span>
          </div>
          <div className="flex gap-6 font-mono text-xs text-gray-400">
            <Link className="hover:text-green-500 hover:underline decoration-green-500 underline-offset-4 transition-all uppercase" to="/terms">
              Terms
            </Link>
            <Link className="hover:text-green-500 hover:underline decoration-green-500 underline-offset-4 transition-all uppercase" to="/privacy">
              Privacy
            </Link>
            <a
              className="hover:text-green-500 hover:underline decoration-green-500 underline-offset-4 transition-all uppercase"
              href="https://discord.gg/aMHV5x6ER7"
              target="_blank"
              rel="noopener noreferrer"
            >
              Discord
            </a>
          </div>
          <div className="text-gray-400 text-xs font-mono">
            SYSTEM_ID: 2026
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 text-center">
          <p className="text-gray-400 text-[10px] font-mono mb-2">
            © 2026 StreetMoneyGaming®. All Rights Reserved.
          </p>
          <p className="text-gray-500 text-[10px] font-mono leading-relaxed max-w-4xl mx-auto">
            StreetMoneyGaming® and the StreetMoneyGaming logo are registered trademarks. All product names, logos, and brands are property of their respective owners.
            Unauthorized reproduction or distribution of any content is strictly prohibited and may result in legal action.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
